import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import CategoryArticles from './pages/CategoryArticles';
import ArticleDetail from './pages/ArticleDetail';
import Feelings from './pages/Feelings';
import AdminArticleRequests from './pages/AdminArticleRequests';
import AdminBulkTagging from './pages/AdminBulkTagging';
import Anonymous from './pages/Anonymous';
import PrayerWall from './pages/PrayerWall';
import Consultations from './pages/Consultations';
import ConsultationDetail from './pages/ConsultationDetail';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import Unsubscribed from './pages/Unsubscribed';
import Testimonials from './pages/Testimonials';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Topics from './pages/Topics';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Resources from './pages/Resources';
import Sanctuary from './pages/Sanctuary';
import SanctuaryDashboard from './pages/SanctuaryDashboard';
import SanctuaryPrayerWall from './pages/SanctuaryPrayerWall';
import SanctuaryRequests from './pages/SanctuaryRequests';
import SanctuaryWelcome from './pages/SanctuaryWelcome';
import ToolsShop from './pages/ToolsShop';
import ToolDetail from './pages/ToolDetail';
import MyTools from './pages/MyTools';
import AdminTools from './pages/AdminTools';
import MeetGenesis from './pages/MeetGenesis';
import AdminMeetGenesis from './pages/AdminMeetGenesis';
import AdminSiteContent from './pages/AdminSiteContent';
import AdminFellowshipModeration from './pages/AdminFellowshipModeration';
import ConnectionRoom from './pages/ConnectionRoom';
import AdminConnectionRoom from './pages/AdminConnectionRoom';
import AdminResources from './pages/AdminResources';
import AdminPrayerEmails from './pages/AdminPrayerEmails';
import AdminSubscribers from './pages/AdminSubscribers';
import FloatingSubscribeButton from './components/FloatingSubscribeButton';
import InstallAppButton from './components/InstallAppButton';
import FloatingBackButton from './components/FloatingBackButton';
import { registerServiceWorker } from './utils/push';

import './App.css';
import { useEffect } from 'react';

export default function App() {
  useEffect(() => { registerServiceWorker(); }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/category/:categoryId" element={<ProtectedRoute><CategoryArticles /></ProtectedRoute>} />
          <Route path="/article/:articleId" element={<ProtectedRoute><ArticleDetail /></ProtectedRoute>} />
          <Route path="/feelings" element={<Feelings />} />
          <Route path="/anonymous" element={<Anonymous />} />
          <Route path="/prayer-wall" element={<PrayerWall />} />
          <Route path="/consultations" element={<ProtectedRoute adminOnly><Consultations /></ProtectedRoute>} />
          <Route path="/consultation/:consultationId" element={<ProtectedRoute adminOnly><ConsultationDetail /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
          <Route path="/unsubscribed" element={<Unsubscribed />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/topics" element={<Topics />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/sanctuary" element={<Sanctuary />} />
          <Route path="/sanctuary/welcome" element={<ProtectedRoute><SanctuaryWelcome /></ProtectedRoute>} />
          <Route path="/sanctuary/dashboard" element={<ProtectedRoute><SanctuaryDashboard /></ProtectedRoute>} />
          <Route path="/sanctuary/prayer-wall" element={<ProtectedRoute><SanctuaryPrayerWall /></ProtectedRoute>} />
          <Route path="/sanctuary/fellowship" element={<ProtectedRoute><SanctuaryPrayerWall /></ProtectedRoute>} />
          <Route path="/sanctuary/requests" element={<ProtectedRoute><SanctuaryRequests /></ProtectedRoute>} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/tools" element={<ToolsShop />} />
          <Route path="/tools/:toolId" element={<ToolDetail />} />
          <Route path="/my-tools" element={<ProtectedRoute><MyTools /></ProtectedRoute>} />
          <Route path="/admin/tools" element={<ProtectedRoute adminOnly><AdminTools /></ProtectedRoute>} />
          <Route path="/meet-genesis" element={<MeetGenesis />} />
          <Route path="/admin/meet-genesis" element={<ProtectedRoute adminOnly><AdminMeetGenesis /></ProtectedRoute>} />
          <Route path="/admin/site-content" element={<ProtectedRoute adminOnly><AdminSiteContent /></ProtectedRoute>} />
          <Route path="/admin/fellowship-moderation" element={<ProtectedRoute adminOnly><AdminFellowshipModeration /></ProtectedRoute>} />
          <Route path="/admin/article-requests" element={<ProtectedRoute adminOnly><AdminArticleRequests /></ProtectedRoute>} />
          <Route path="/admin/bulk-tag" element={<ProtectedRoute adminOnly><AdminBulkTagging /></ProtectedRoute>} />
          <Route path="/sanctuary/connection-room" element={<ProtectedRoute><ConnectionRoom /></ProtectedRoute>} />
          <Route path="/admin/connection-room" element={<ProtectedRoute adminOnly><AdminConnectionRoom /></ProtectedRoute>} />
          <Route path="/admin/resources" element={<ProtectedRoute adminOnly><AdminResources /></ProtectedRoute>} />
          <Route path="/admin/prayer-emails" element={<ProtectedRoute adminOnly><AdminPrayerEmails /></ProtectedRoute>} />
          <Route path="/admin/subscribers" element={<ProtectedRoute adminOnly><AdminSubscribers /></ProtectedRoute>} />
        </Routes>
        <FloatingBackButton />
        <InstallAppButton />
        <FloatingSubscribeButton />
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}
